import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set">

            <KPI
                title="Lead totali"
                icon="faPerson"
                className="highlighted"
                dataProviderName={'statistics/item/count/audiences/audienceLead'}
            />
            <KPI
                title="Lead in blacklist"
                icon="faUserXmark"
                dataProviderName={'statistics/item/count/audiences/audienceBlackList'}
            />
            {/* <KPI
                title="Lead B2B in blacklist"
                icon="faUserXmark"
                dataProviderName={'statistics/item/count/audiences/audienceBlackList'}
                filters={{
                    items: [
                        {
                            'field': 'audienceLead.type',
                            'operator': '=',
                            'value': 'business'
                        }
                    ]
                }}
            />
            <KPI
                title="Lead B2C in blacklist"
                icon="faUserXmark"
                dataProviderName={'statistics/item/count/audiences/audienceBlackList'}
                filters={{
                    items: [
                        {
                            'field': 'audienceLead.type',
                            'operator': '=',
                            'value': 'retail'
                        }
                    ]
                }}
            /> */}

        </Box>
    )
}

export default KPISet;